
import {
    type LucideIcon,
    type LucideProps,
} from "lucide-react";



export type Icon = LucideIcon;




export function XTwitterIcon(props: LucideProps) {
    return (
        <svg
            aria-label="X (formerly known as Twitter)"
            fill="currentColor"
            viewBox="0 0 22 20"

            {...props}
        >
            <path d="M16.99 0H20.298L13.071 8.26L21.573 19.5H14.916L9.702 12.683L3.736 19.5H0.426L8.156 10.665L0 0H6.826L11.539 6.231L16.99 0ZM15.829 17.52H17.662L5.83 1.876H3.863L15.829 17.52Z"></path>
        </svg>
    );
}

export function InstagramPhone(props: LucideProps) {
    return (
        <svg {...props} aria-label="Llamada de audio" fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M18.227 22.912c-4.913 0-9.286-3.627-11.486-5.828C4.486 14.83.731 10.291.921 5.231a3.289 3.289 0 0 1 .908-2.138 17.116 17.116 0 0 1 1.865-1.71 2.307 2.307 0 0 1 3.004.174 13.283 13.283 0 0 1 3.658 5.325 2.551 2.551 0 0 1-.19 1.941l-.455.853a.463.463 0 0 0-.024.387 7.57 7.57 0 0 0 4.077 4.075.455.455 0 0 0 .386-.024l.853-.455a2.548 2.548 0 0 1 1.94-.19 13.278 13.278 0 0 1 5.326 3.658 2.309 2.309 0 0 1 .174 3.003 17.319 17.319 0 0 1-1.71 1.866 3.29 3.29 0 0 1-2.138.91 10.27 10.27 0 0 1-.368.006Zm-13.144-20a.27.27 0 0 0-.167.054A15.121 15.121 0 0 0 3.28 4.47a1.289 1.289 0 0 0-.36.836c-.161 4.301 3.21 8.34 5.235 10.364s6.06 5.403 10.366 5.236a1.284 1.284 0 0 0 .835-.36 15.217 15.217 0 0 0 1.504-1.637.324.324 0 0 0-.047-.41 11.62 11.62 0 0 0-4.457-3.119.545.545 0 0 0-.411.044l-.854.455a2.452 2.452 0 0 1-2.071.116 9.571 9.571 0 0 1-5.189-5.188 2.457 2.457 0 0 1 .115-2.071l.456-.855a.544.544 0 0 0 .043-.41 11.629 11.629 0 0 0-3.118-4.458.36.36 0 0 0-.244-.1Z">
            </path>
        </svg>
    )
}

export function InstagramVideo(props: LucideProps) {
    return (
        <svg aria-label="Videollamada" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <rect fill="none" height="18" rx="3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" width="16.999" x="1" y="3">
            </rect>
            <path d="m17.999 9.146 2.495-2.256A1.5 1.5 0 0 1 23 8.003v7.994a1.5 1.5 0 0 1-2.506 1.113L18 14.854" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            </path>
        </svg>
    )
}

export function InstagramInfo(props: LucideProps) {
    return (
        <svg aria-label="Información de la conversación" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <circle cx="12.001" cy="12.005" fill="none" r="10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></circle>
            <circle cx="11.819" cy="7.709" r="1.25"></circle><line fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" x1="10.569" x2="13.432" y1="16.777" y2="16.777">
            </line>
            <polyline fill="none" points="10.569 11.05 12 11.05 12 16.777" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            </polyline>
        </svg>
    )
}

export function InstagramEmoji(props: LucideProps) {
    return (
        <svg aria-label="Elige un emoji" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M15.83 10.997a1.167 1.167 0 1 0 1.167 1.167 1.167 1.167 0 0 0-1.167-1.167Zm-6.5 1.167a1.167 1.167 0 1 0-1.166 1.167 1.167 1.167 0 0 0 1.166-1.167Zm5.163 3.24a3.406 3.406 0 0 1-4.982.007 1 1 0 1 0-1.557 1.256 5.397 5.397 0 0 0 8.09 0 1 1 0 0 0-1.55-1.263ZM12 .503a11.5 11.5 0 1 0 11.5 11.5A11.513 11.513 0 0 0 12 .503Zm0 21a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5Z"></path>
        </svg>
    )
}


export function InstagramMicrophone(props: LucideProps) {
    return (
        <svg aria-label="Clip de voz" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M19.5 10.671v.897a7.5 7.5 0 0 1-15 0v-.897" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
            <line fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" x1="12" x2="12" y1="19.068" y2="22"></line>
            <line fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" x1="8.706" x2="15.104" y1="22" y2="22"></line>
            <path d="M12 15.745a4 4 0 0 1-4-4V6a4 4 0 0 1 8 0v5.745a4 4 0 0 1-4 4Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
        </svg>
    )
}

export function InstagramImage(props: LucideProps) {
    return (
        <svg aria-label="Añadir foto o vídeo" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M6.549 5.013A1.557 1.557 0 1 0 8.106 6.57a1.557 1.557 0 0 0-1.557-1.557Z" fillRule="evenodd"></path>
            <path d="m2 18.605 3.901-3.9a.908.908 0 0 1 1.284 0l2.807 2.806a.908.908 0 0 0 1.283 0l5.534-5.534a.908.908 0 0 1 1.283 0l3.905 3.905" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2"></path>
            <path d="M18.44 2.004A3.56 3.56 0 0 1 22 5.564h0v12.873a3.56 3.56 0 0 1-3.56 3.56H5.568a3.56 3.56 0 0 1-3.56-3.56V5.563a3.56 3.56 0 0 1 3.56-3.56Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
        </svg>
    )
}

export function InstagramSticker(props: LucideProps) {

    return (
        <svg aria-label="Elige un gif o un sticker" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M13.11 22H7.416A5.417 5.417 0 0 1 2 16.583V7.417A5.417 5.417 0 0 1 7.417 2h9.166A5.417 5.417 0 0 1 22 7.417v5.836a2.083 2.083 0 0 1-.626 1.488l-6.808 6.664A2.083 2.083 0 0 1 13.11 22Z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
            <circle cx="8.238" cy="9.943" r="1.335"></circle>
            <circle cx="15.762" cy="9.943" r="1.335"></circle>
            <path d="M15.174 15.23a4.887 4.887 0 0 1-6.937-.301" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
            <path d="M22 10.833v1.629a1.25 1.25 0 0 1-1.25 1.25h-1.79a5.417 5.417 0 0 0-5.417 5.417v1.62a1.25 1.25 0 0 1-1.25 1.25H9.897" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
        </svg>

    )
}


export function InstagramHeart(props: LucideProps) {
    return (
        <svg aria-label="Me gusta" {...props} fill="currentColor" height="24" role="img" viewBox="0 0 24 24" width="24">
            <path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z"></path>
        </svg>

    )

}

export function LinkedinEmoji(props: LucideProps) {
    return (
        <svg fill="currentColor" height="16" role="img" viewBox="0 0 16 16" width="16" {...props} >
            <path d="M4.84 6A1.16 1.16 0 116 7.17 1.17 1.17 0 014.84 6zM8 9.38a3.51 3.51 0 01-2.3-.81l-.83 1.29a4.87 4.87 0 006.25 0l-.82-1.28a3.51 3.51 0 01-2.3.8zm2-4.55A1.17 1.17 0 1011.16 6 1.17 1.17 0 0010 4.83zM8 2.88A5.12 5.12 0 112.88 8 5.12 5.12 0 018 2.88M8 1a7 7 0 107 7 7 7 0 00-7-7z"></path>
        </svg>
    )
}

export function LinkedinImage(props: LucideProps) {
    return (
        <svg role="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-supported-dps="16x16" data-test-icon="image-small" {...props} >

<path d="M12 2H4C2.35 2 1 3.35 1 5v6c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3zm1 9l-2-2-1.5 1.5L6 7l-3 3V5c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v6zm-1-4.5c0 .82-.67 1.5-1.5 1.5S9 7.32 9 6.5 9.67 5 10.5 5s1.5.67 1.5 1.5z"></path>
        </svg>
    )
}

export function LinkedinAttachment(props: LucideProps) {
    return (
        <svg role="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-supported-dps="16x16" data-test-icon="attachment-small" fill="currentColor"  {...props} >
          <path d="M15 5a4 4 0 01-1.17 2.83l-3.46 3.46A2.5 2.5 0 018.6 12a2.46 2.46 0 01-2.5-2.48 2.55 2.55 0 01.75-1.79L9.61 5 11 6.39 8.25 9.17a.49.49 0 00-.15.35.5.5 0 00.9.36l3.46-3.47a2 2 0 10-2.87-2.82l-6 6A2 2 0 005 13a2 2 0 001.42-.59l.18-.17L8 13.66l-.17.17a4 4 0 01-5.66-5.66l6-6A4 4 0 0115 5z"></path>
        </svg>
    )
}

export function LinkedinGif(props: LucideProps) {
    return (
        <svg role="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-supported-dps="16x16" data-test-icon="gif-small" fill="currentColor" {...props} >

<path d="M12 6v1h2v2h-2v3h-2V4h5v2h-3zm-5 6h2V4H7v8zM1 6v4c0 1.1.9 2 2 2 .39 0 .74-.01 1.63-.74L5 12h1V8H4v2H3V6h3V4H3c-1.1 0-2 .9-2 2z"></path>
        </svg>
    )
}

// export function LinkedinCamera(props: LucideProps) {
//     return (
//         <svg role="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-supported-dps="16x16" data-test-icon="video-conference-small" fill="currentColor" {...props} >
//             <use href="#video-conference-small" width="16" height="16"></use>
//         </svg>
//     )
// }

export function LinkedinOverflow(props: LucideProps) {

    return (
        <svg role="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" data-supported-dps="16x16" data-test-icon="overflow-web-ios-small" fill="currentColor" {...props} >
<path d="M3 9.5A1.5 1.5 0 114.5 8 1.5 1.5 0 013 9.5zM11.5 8A1.5 1.5 0 1013 6.5 1.5 1.5 0 0011.5 8zm-5 0A1.5 1.5 0 108 6.5 1.5 1.5 0 006.5 8z"></path>
        </svg>
    )
}


export function LinkedinChevronUpSmall(props: LucideProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="chevron-up-small" aria-hidden="true" role="none" data-supported-dps="16x16" fill="currentColor" {...props}>
        <path d="M15 11L8 6.39 1 11V8.61L8 4l7 4.61z"></path>
      </svg>
    )
}




export const InstagramIcons = {
    phone: InstagramPhone,
    video: InstagramVideo,
    info: InstagramInfo,
    emoji: InstagramEmoji,
    microphone: InstagramMicrophone,
    image: InstagramImage,
    sticker: InstagramSticker,
    heart: InstagramHeart,
};

export const LinkedinIcons = {
    emoji: LinkedinEmoji,
    image: LinkedinImage,
    attachment: LinkedinAttachment,
    gif: LinkedinGif,
    // camera: LinkedinCamera,
    overflow: LinkedinOverflow,
    chevronUpSmall: LinkedinChevronUpSmall,
};

